export const typeEducationalBackgroundChartCalculation = (props: any) => {
    const {uoas, fields} = props;
    const educationalBackgroundField = fields.find((field: any) => field.key === 'educational-background');
    let data: any = [];

    if (educationalBackgroundField) {
        data = educationalBackgroundField.options.map((option: any) => ({
            name: option.name,
            y: uoas.filter(
                (uoa: any) =>
                    uoa.custom_field_values
                        .find((custom_field_value: any) => custom_field_value.field_id === educationalBackgroundField.id)?.stored_value === String(option.id)
            ).length
        }));
    }

    return {
        chart: {
            type: 'column',
        },
        title: {
            text: 'Type of educational background',
            align: 'left',
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
            },
        },
        xAxis: {
            categories: data.map((el: any) => el.name),
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
            },
        },
        series: [
            {
                showInLegend: false,
                name: 'Number',
                data: data.map((el: any) => el.y),
                type: 'column',
                dataLabels: {
                    enabled: true,
                },
            },
        ],
    };
}